import { FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { NumberUtils } from 'src/app/product-capture/utils/number.utils';

export const capVsDiscountCertificateValidator: ValidatorFn = (
  control: FormGroup
): ValidationErrors | null => {
  const cap = control.get('globalCap');
  const discountPrice = control.get('strike');

  const capUnit = cap.value?.value?.indexOf('%') > -1 ? 'pct' : 'abs';
  const discountPriceUnit =
    discountPrice.value?.value?.indexOf('%') > -1 ? 'pct' : 'abs';

  let err = null;

  if (
    capUnit === discountPriceUnit &&
    NumberUtils.stringToNumber(cap.value?.value) <
      NumberUtils.stringToNumber(discountPrice.value?.value)
  ) {
    err = { capVsdiscountPrice: true };
  } else if (capUnit !== discountPriceUnit) {
    const isDiscountPriceGreater = NumberUtils.isNumberGreaterThanConvertUnits(
      discountPrice.value?.value,
      cap.value?.value
    );

    if (isDiscountPriceGreater) {
      err = { capVsdiscountPrice: true };
    }
  }

  cap.setErrors(err);
  discountPrice.setErrors(err);

  return err;
};
